import { ICheckPlateDto, ICreateVehicleBanDto, ILiftVehicleBanDto, IUpdateVehicleBanDto, IVehicleBanQueryDto } from '@/types/vehicle-bans';

import { instance } from './config';

const entityName = 'vehicle-bans';

export const getVehicleBans = async (query?: IVehicleBanQueryDto) => {
  const searchParams = new URLSearchParams();
  if (query) {
    Object.entries(query).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') searchParams.append(key, String(value));
    });
  }
  return instance(`${entityName}?${searchParams.toString()}`);
};

export const getVehicleBanById = async (id: string) => {
  return instance(`${entityName}/${id}`);
};

export const createVehicleBan = async (body: ICreateVehicleBanDto) => {
  return instance(entityName, {
    method: 'POST',
    body: JSON.stringify(body)
  });
};

export const updateVehicleBan = async (id: string, body: IUpdateVehicleBanDto) => {
  return instance(`${entityName}/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(body)
  });
};

export const liftVehicleBan = async (id: string, body: ILiftVehicleBanDto) => {
  return instance(`${entityName}/${id}/lift`, {
    method: 'POST',
    body: JSON.stringify(body)
  });
};

export const getVehicleBansByVehicleId = async (vehicleId: number) => {
  return instance(`${entityName}/vehicle/${vehicleId}`);
};

export const getActiveVehicleBan = async (vehicleId: number) => {
  return instance(`${entityName}/vehicle/${vehicleId}/active`);
};

export const checkVehiclePlate = async (body: ICheckPlateDto) => {
  return instance(`${entityName}/check`, {
    method: 'POST',
    body: JSON.stringify(body)
  });
};

export const getVehicleBanAttempts = async (banId: string) => {
  return instance(`${entityName}/${banId}/attempts`);
};
